import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { userFavorite, getProduct, deleteFavorite } from "../axios";
import { separate } from "../tools/helper";
import { toast } from "react-toastify";
import { CartContext } from "../components/shared/context/cart-context";
import { ExistDataContext } from "../components/shared/context/dataExist-context";

const Wishlist = () => {
  const [favorites, setFavorites] = useState([]);
  const location = useLocation();
  const removeFavorite = (e, id) => {
    e.preventDefault();
    deleteFavorite(id, localStorage.getItem("phonenumber")).then(({ data }) => {
      toast.success("محصول مورد نظر با موفقیت از لیست حذف شد");
      fetchUserFavrite();
      window.location.reload();
    });
  };

  const fetchUserFavrite = () => {
    userFavorite(localStorage.getItem("phonenumber")).then(({ data }) => {
      data.map((item) => {
        getProduct(item.productID).then(({ data }) => {
          setFavorites((prevState) => [...prevState, data[0]]);
        });
      });
    });
  };

  useEffect(() => {
    fetchUserFavrite();
  }, [location.pathname]);

  const [cartItems, setCartItems] = useContext(CartContext);
  const [existProduct] = useContext(ExistDataContext);
  const existsInArray = (array, id) => {
    return array.some((item) => item.productID === id);
  };
  const existsInArraySecond = (array, id) => {
    return array.some((item) => item.id === id);
  };

  const addToBasketHandler = (e, value) => {
    e.preventDefault();
    if (localStorage.getItem("login")) {
      let Basket = [...cartItems];
      const existDataInBasketHistory = existsInArray(existProduct, value.id);

      const existItemInBasket = existsInArraySecond(cartItems, value.id);

      if (value.categoryID === 1) {
        try {
          Basket.push(value);
          setCartItems(Basket);
          toast.success("به سبد خرید اضافه شد");
        } catch (error) {
          console.log(error.message);
        }
      } else {
        if (existDataInBasketHistory === false) {
          if (existItemInBasket == false) {
            try {
              Basket.push(value);
              setCartItems(Basket);
              toast.success("به سبد خرید اضافه شد");
            } catch (error) {
              console.log(error.message);
            }
          } else {
            toast.error(
              "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
            );
          }
        } else {
          return toast.error("این محصول قبلا خریداری شده است.");
        }
      }
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  // const addToBasketHandler = (e, value) => {
  //   e.preventDefault();

  //   const existData = existsInArray(existProduct, value.id);
  //   if (existData === false) {
  //     if (localStorage.getItem("login")) {
  //       try {
  //         let array = [...cartItems];
  //         array.push(value);
  //         setCartItems(array);
  //         toast.success("به سبد خرید اضافه شد");
  //       } catch (error) {
  //         console.log(error.message);
  //       }
  //     } else {
  //       toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
  //     }
  //   } else {
  //     return toast.error("این محصول قبلا خریداری شده است.");
  //   }
  // };

  const [favoriteList, setFavoriteList] = useState([]);
  useEffect(() => {
    const ids = new Set();
    const result = favorites.filter((obj) => {
      if (ids.has(obj.id)) {
        return false; // remove object
      }
      ids.add(obj.id);
      return true; // keep object
    });
    setFavoriteList(result);
  }, [favorites]);

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>لیست علاقه‌مندی‌ها</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="wishlist_area mt-60">
        <div className="container">
          <form action="#">
            <div className="row">
              <div className="col-12">
                <div className="table_desc wishlist">
                  <div className="cart_page table-responsive">
                    {favoriteList.length === 0 ? (
                      <p>لیست علاقه مندی های شما خالی است!</p>
                    ) : (
                      <table>
                        <thead>
                          <tr>
                            <th className="product_remove">حذف</th>
                            <th className="product_thumb">تصویر</th>
                            <th className="product_name">محصول</th>
                            <th className="product-price">قیمت</th>
                            <th className="product_quantity">وضعیت انبار</th>
                            <th className="product_total">افزودن به سبد</th>
                          </tr>
                        </thead>
                        <tbody>
                          {favoriteList.map(
                            (item) =>
                              item.isSite === true && (
                                <tr>
                                  <td className="product_remove">
                                    <a
                                      onClick={(e) =>
                                        removeFavorite(e, item.id)
                                      }
                                      href="#"
                                    >
                                      ×
                                    </a>
                                  </td>
                                  <td className="product_thumb">
                                    <Link to={`/product/${item.id}`}>
                                      <img src={item.img} alt="" />
                                    </Link>
                                  </td>
                                  <td className="product_name">
                                    <Link to={`/product/${item.id}`}>
                                      {item.title}
                                    </Link>
                                  </td>
                                  <td className="product-price">
                                    تومان {separate(item.priceTakhfif)}
                                  </td>
                                  <td className="product_quantity">
                                    موجود در انبار
                                  </td>
                                  <td className="product_total">
                                    <a
                                      onClick={(e) =>
                                        addToBasketHandler(e, item)
                                      }
                                      href="#"
                                    >
                                      افزودن به سبد
                                    </a>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Wishlist;

//  {/* <div className="row">
//         <div className="col-12">
//           <div className="wishlist_share">
//             <h4>اشتراک گذاری در:</h4>
//             <ul>
//               <li>
//                 <a href="#">
//                   <i className="fa fa-rss"></i>
//                 </a>
//               </li>
//               <li>
//                 <a href="#">
//                   <i className="fa fa-vimeo"></i>
//                 </a>
//               </li>
//               <li>
//                 <a href="#">
//                   <i className="fa fa-tumblr"></i>
//                 </a>
//               </li>
//               <li>
//                 <a href="#">
//                   <i className="fa fa-telegram"></i>
//                 </a>
//               </li>
//               <li>
//                 <a href="#">
//                   <i className="fa fa-linkedin"></i>
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div> */}
